<form #uploadForm="ngForm" (ngSubmit)="onSubmit()">
    <input type="file" name="file" (change)="onFileChange($event)" />
    <button class="secondary">Nahrát</button>
</form>